export interface EDocs {
  files?: Array<EDocsFile>;
  folders?: Array<EDocsFolder>;
}

export interface EDocsFile {
  uuid: string;
  date: string;
  title: string;
  attachmentType: string;
  attachmentLabel?: string;
  href?: string;
  extension?: string;
  mimeType?: string;
  lastAuthor?: string;
  parentFolderUuid?: string;
}

export interface EDocsFolder {
  uuid: string;
  title: string;
  lastAuthor: string;
  isSelected?: boolean;
  files?: Array<EDocsFile>;
}
